import React from 'react';
import styled from 'styled-components'
import {PRIMARY_GRAY} from "../constants/COLORS";


export const CallerCardBase = styled.div`
  width: 600px;
  height: 750px;
  box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.15);
  font-family: Quicksand, sans-serif;
  color: ${PRIMARY_GRAY};
  padding: 1.3rem;
  text-transform: uppercase;
  margin-bottom: 1.5rem;
  position: relative;
  box-sizing: border-box;
  
  @media only screen and (max-width: 675px){
   width: 100%;
   table, tbody, tr{
    width: 100%;
    margin: 0;
    padding: 0;
   }
   
   td{
    display: block;
    margin: 0;
    padding: 0 0 0 7vw;
    text-align: left !important;
   }
   td:first-child{
   font-size: 0.7rem;
   }
   td:last-child{
    font-size: 1rem;
    padding-left: 10vw !important;
    margin-bottom: 1rem;
   }
   tr:last-child{
      td{
      display: inline-block;
      padding: 1rem 0.5rem  !important;
      margin: 0 !important;
      }
      td:first-child{
       width: 40%;
       }
       td:last-child{
        width: 60%;
       }
   }
     @media only screen and (max-width: 500px){
    tr:last-child{
      td{
      display: block;
      padding: 0.5rem  !important;
      margin: 0 !important;
      width: 100% !important;
      max-width: none !important;
      }
      
   }
    
    
    }
  }
`

